import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Helmet } from "react-helmet";
import "./ProjectsFAQ.css";

const projectsPageFaqData = [
  {
    q: "What type of projects does Oglitz work on?",
    a: (
      <>
        Oglitz builds enterprise-grade{" "}
        <a href="/services-technologies">web applications</a>,{" "}
        <a href="/services-technologies">mobile apps</a>, SaaS platforms,
        e-commerce solutions, and custom software for startups and enterprises
        worldwide.
      </>
    ),
  },
  {
    q: "Do you develop scalable and enterprise-ready solutions?",
    a: (
      <>
        Yes. Our projects are built using scalable architectures with cloud
        platforms like AWS, Azure, and Google Cloud, ensuring security,
        performance, and long-term growth.
      </>
    ),
  },
  {
    q: "Can you improve or redesign an existing project?",
    a: (
      <>
        Absolutely. We provide UI/UX redesign, performance optimization,
        architecture refactoring, and feature enhancement services for existing
        digital products.
      </>
    ),
  },
  {
    q: "Do you work with international clients?",
    a: (
      <>
        Yes. Oglitz works with clients across UAE, India, USA, UK, Europe, and
        other global markets through structured remote collaboration.
      </>
    ),
  },
];

const faqSchemaProjects = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: projectsPageFaqData.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: "Visit Oglitz Projects page for detailed explanation.",
    },
  })),
};

const ProjectsFAQ = ({ theme = "light" }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      {/* SEO FAQ Schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchemaProjects)}
        </script>
      </Helmet>

      <section
        className={`oglitz-projects-faq-root oglitz-projects-faq-${theme}`}
        aria-labelledby="oglitz-projects-faq-heading"
      >
        <div className="oglitz-projects-faq-wrapper">
          {/* Header */}
          <header className="oglitz-projects-faq-header">
            <span className="oglitz-projects-faq-pill">FAQs</span>

            <h2
              id="oglitz-projects-faq-heading"
              className="oglitz-projects-faq-title"
            >
              Frequently Asked <span>Questions</span>
            </h2>

            <p className="oglitz-projects-faq-subtitle">
              Clear answers about our projects, technologies, and global
              delivery model.
            </p>
          </header>

          {/* FAQ List */}
          <div className="oglitz-projects-faq-list">
            {projectsPageFaqData.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <article
                  key={index}
                  className={`oglitz-projects-faq-item ${
                    isOpen ? "is-open" : ""
                  }`}
                >
                  <button
                    className="oglitz-projects-faq-question"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    <span>{item.q}</span>
                    <FaChevronDown className="oglitz-projects-faq-icon" />
                  </button>

                  <div className="oglitz-projects-faq-answer">
                    <p>{item.a}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectsFAQ;
